<template>
	<c-dialog ref="dialog" height="400" width="600" @resolve="editHandle">
		<c-form ref="form" unit-width="100%">
      <c-input type="hidden" name="id"></c-input>
      <c-form-item label="分类" required tip="请选择品牌关联分类，支持多选">
        <c-select name="category_ids" async multiple @search="searchCategory" :value-data="selectedCategory"></c-select>
      </c-form-item>
      <c-form-item label="品牌名称" required tip="品牌名称不允许重复">
				<c-input name="brand_name" maxlength="20"></c-input>
			</c-form-item>
      <c-form-item label="品牌图片">
        <c-upload-file name="img_url" type="image" size="1024" button="请选择图片" media></c-upload-file>
      </c-form-item>
			<c-form-item label="备注">
        <c-input type="textarea" name="remark"></c-input>
			</c-form-item>
    </c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {
	computed: {
	},
	
	data() {
		return {
			  editState: false,
        selectedCategory:[] //已选中的分类
		}
	},

	methods: {
    /*******搜索分类*****************/
    searchCategory(keyword, resolve){
      this.request({
        url:'/spu/category/options',
        data: {
          keyword: keyword
        },
        success:data => {
          resolve(data);
        }
      })
    },
    /*******查询品牌详情*****************/
    getDetail(id){
      this.request({
        url:'/spu/brand/detail',
        data: {
          id: id
        },
        success:data => {
          if (data && data.category_list){
            //已选中的[分类]
            this.selectedCategory = data.category_list.map(item => {
              return {
                name: item.category_name,
                value:item.category_id
              }
            });
          }
        }
      })
    },
		/*********打开编辑框，初始化**********/
		open(data) {
			this.editState = !!data;
			this.$refs.form.clear();
			if (data) {
				this.getDetail(data.id);
				this.$refs.form.set(data);
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑品牌' : '添加品牌'
			});
		},

		/*******添加、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.editState?'/spu/brand/edit':'/spu/brand/add',
				rule: {
                  category_ids: '请选择品牌关联的分类',
                  brand_name: '请输入品牌名称'
				},
				dataFormatter: data => {
					return data;
				},
				success: (data, res) => {
					next();
					if(this.editState){
						this.$message({
							message: '编辑成功',  // 提示内容,
							type: 'success'
						});
					}else{
            this.$message({
              message: '添加成功',  // 提示内容,
              type: 'success'
            });
					}
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>